module.exports = __webpack_public_path__ + "img/contentImgHover1.73a2979.webp";